export * from './variant.page';
